{
  "name": "econnect.worker",
  "version": "5.6.0",
  "scripts": {
    "ng": "ng",
    "start": "set NODE_OPTIONS=--max_old_space_size=8192 & ng serve --open",
    "start-hmr": "ng serve --configuration hmr --source-map=false --hmr-warning=false",
    "start-hmr-sourcemaps": "ng serve --configuration hmr --source-map=true --hmr-warning=false",
    "build": "node --max_old_space_size=8192 ./node_modules/@angular/cli/bin/ng build",
    "build-stats": "node --max_old_space_size=8192 ./node_modules/@angular/cli/bin/ng build --stats-json",
    "build:prod": "node --max_old_space_size=8192 ./node_modules/@angular/cli/bin/ng build --configuration production --aot && npm run postbuild && npm run sentry:sourcemaps",
    "build:prod-stats": "node --max_old_space_size=8192 ./node_modules/@angular/cli/bin/ng build --configuration production --stats-json",
    "bundle-analyzer": "webpack-bundle-analyzer dist/worker/stats.json",
    "test": "ng test",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "postbuild": "node ./build/post-build.js",
    "sentry:sourcemaps": "sentry-cli sourcemaps inject --org endepro-software --project worker ./dist/worker && sentry-cli sourcemaps upload --org endepro-software --project worker ./dist/worker"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "21.0.6",
    "@angular/cdk": "21.0.5",
    "@angular/common": "21.0.6",
    "@angular/compiler": "21.0.6",
    "@angular/core": "21.0.6",
    "@angular/forms": "21.0.6",
    "@angular/localize": "21.0.6",
    "@angular/material": "21.0.5",
    "@angular/platform-browser": "21.0.6",
    "@angular/platform-browser-dynamic": "21.0.6",
    "@angular/router": "21.0.6",
    "@circlon/angular-tree-component": "^11.0.4",
    "@iarna/rtf-to-html": "^1.1.0",
    "@ng-bootstrap/ng-bootstrap": "^20.0.0",
    "@ng-select/ng-select": "^21.1.3",
    "@ngx-translate/core": "^17.0.0",
    "@sentry/angular": "^10.32.1",
    "@sentry/cli": "^3.0.1",
    "@siemens/ngx-datatable": "^25.0.0",
    "@sweetalert2/ngx-sweetalert2": "^14.1.1",
    "@types/lodash": "^4.17.21",
    "angular-auth-oidc-client": "^21.0.1",
    "animate.css": "4.1.1",
    "assert": "^2.1.0",
    "autoprefixer": "^10.4.23",
    "bootstrap": "^5.3.8",
    "bs-stepper": "1.7.0",
    "buffer": "^6.0.3",
    "compress-json": "^3.4.0",
    "core-js": "^3.47.0",
    "feather-icons": "^4.29.2",
    "flatpickr": "^4.6.13",
    "jwt-decode": "^4.0.0",
    "lodash": "^4.17.21",
    "moment": "^2.30.1",
    "ng-block-ui": "^4.0.1",
    "ng-circle-progress": "^1.7.1",
    "ng2-cookies": "^1.0.12",
    "ngx-doc-viewer": "^15.0.1",
    "ngx-echarts": "^21.0.0",
    "ngx-highlightjs": "^14.0.1",
    "ngx-logger": "^5.0.12",
    "ngx-scrollbar": "^19.1.0",
    "ngx-toastr": "^19.1.0",
    "node-waves": "0.7.6",
    "pako": "^2.1.0",
    "process": "^0.11.10",
    "rxjs": "^7.8.2",
    "sweetalert2": "^11.26.17",
    "tslib": "^2.8.1",
    "util": "^0.12.5",
    "uuidv4": "^6.2.13",
    "websocket-ts": "^2.2.1",
    "zone.js": "^0.16.0"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^21.0.4",
    "@angular/cli": "^21.0.4",
    "@angular/compiler-cli": "21.0.6",
    "@angular/language-service": "21.0.6",
    "@angularclass/hmr": "^3.0.0",
    "@types/jasmine": "^5.1.13",
    "@types/node": "^25.0.3",
    "@types/pako": "^2.0.4",
    "codelyzer": "^6.0.2",
    "jasmine-core": "^5.13.0",
    "karma": "^6.4.4",
    "karma-chrome-launcher": "^3.2.0",
    "karma-coverage": "^2.2.1",
    "karma-coverage-istanbul-reporter": "^3.0.3",
    "karma-jasmine": "^5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "typescript": "5.9.3",
    "webpack-bundle-analyzer": "^5.1.0"
  }
}